<div class="min-h-screen bg-background text-foreground relative selection:bg-primary/20 selection:text-primary">
  <!-- Top decorative bar — brand green → crimson → gold, as on the landing page -->
  <div class="brand-gradient-bar h-1.5 w-full"></div>

  <!-- Header bar -->
  <header class="border-b border-border/70 bg-card/90 backdrop-blur-md sticky top-0 z-30 shadow-sm transition-all">
    <div class="max-w-5xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between gap-4">
      <a
        routerLink="/"
        hlmBtn
        variant="ghost"
        size="sm"
        class="inline-flex items-center gap-2 font-semibold text-muted-foreground hover:text-deep-green -ml-2"
      >
        <ng-icon name="lucideArrowLeft" class="size-4" />
        <span>Back to Home</span>
      </a>

      <!-- Organisation mark, carried over from the landing header -->
      <div class="flex items-center gap-2.5">
        <div class="w-9 h-9 rounded-full border-2 border-[#0A3D2F]/15 overflow-hidden bg-white flex items-center justify-center shrink-0">
          <img
            src="/assets/icon/ancLogo.jpeg"
            alt="ANC Logo"
            class="w-full h-full object-cover"
            onerror="this.style.opacity='0.2'"
          />
        </div>
        <div class="hidden md:block leading-tight">
          <p class="text-[13px] font-bold text-deep-green">ANC GHANA</p>
          <p class="text-[9px] font-bold tracking-[1.5px] uppercase text-gold">One Nation, One People</p>
        </div>
      </div>

      <div class="flex items-center gap-3">
        <!-- <div
          class="hidden sm:flex items-center gap-2 px-3 py-1 rounded-full bg-gold-light text-[#8A6A1F] border border-gold/30 text-xs font-semibold"
        >
          <ng-icon name="lucideShieldCheck" class="size-3.5 text-gold" />
          <span>Official Registration Portal</span>
        </div> -->
        <span
          hlmBadge
          variant="outline"
          class="font-bold border-primary/30 text-primary bg-primary/5 whitespace-nowrap"
        >
          Step {{ currentStep() + 1 }} of {{ steps.length }}
        </span>
      </div>
    </div>
  </header>

  <div class="max-w-4xl mx-auto px-4 sm:px-6 py-8 sm:py-12">
    <!-- Section eyebrow + title, matching the landing page's section rhythm -->
    <div class="text-center mb-8 sm:mb-10">
      <span class="text-gold font-bold tracking-[3px] uppercase text-[11px] sm:text-xs mb-3 block">
        Membership Registration
      </span>
      <h1 class="text-2xl sm:text-4xl font-black text-deep-green tracking-tight mb-3">
        {{ steps[currentStep()].label }}
      </h1>
      <p class="text-sm sm:text-base text-muted-foreground max-w-md mx-auto">
        {{ steps[currentStep()].description }}
      </p>
      <hlm-separator class="w-16 h-1 bg-deep-green mx-auto rounded-full mt-5" />
    </div>

    <!-- Stepper Section -->
    <div class="mb-10 sm:mb-12">
      <!-- Horizontal Stepper -->
      <div class="flex items-center justify-between max-w-2xl mx-auto px-2">
        @for (step of steps; track step.label; let stepIndex = $index) {
          <div class="flex flex-col items-center gap-2 relative z-10 group cursor-default">
            <div
              class="flex justify-center items-center rounded-full transition-all duration-300 font-bold"
              [style.width]="stepIndex === currentStep() ? '42px' : '34px'"
              [style.height]="stepIndex === currentStep() ? '42px' : '34px'"
              [class]="
                stepIndex < currentStep()
                  ? 'step-complete'
                  : stepIndex === currentStep()
                    ? 'step-current'
                    : 'step-upcoming border-2'
              "
            >
              @if (stepIndex < currentStep()) {
                <ng-icon name="lucideCheck" class="size-4 stroke-[3]" />
              }
              @if (stepIndex === currentStep()) {
                <span class="text-sm font-bold">{{ stepIndex + 1 }}</span>
              }
              @if (stepIndex > currentStep()) {
                <span class="text-xs font-medium">{{ stepIndex + 1 }}</span>
              }
            </div>
            <div class="text-center">
              <span
                class="text-[11px] sm:text-xs font-bold leading-tight block max-w-[80px] select-none transition-colors"
                [class]="
                  stepIndex === currentStep()
                    ? 'text-deep-green'
                    : stepIndex < currentStep()
                      ? 'text-foreground font-semibold'
                      : 'text-muted-foreground'
                "
              >
                {{ step.label }}
              </span>
            </div>
          </div>

          @if (stepIndex < steps.length - 1) {
            <div
              class="flex-1 h-[2px] rounded-full mx-2 sm:mx-4 -mt-6 transition-all duration-500"
              [class]="stepIndex < currentStep() ? 'step-line-done' : 'step-line-upcoming'"
            ></div>
          }
        }
      </div>
    </div>

    <!-- Current Step Content Shell -->
    <div
      hlmCard
      class="rounded-2xl sm:rounded-[2rem] p-6 sm:p-10 border-0 bg-card text-card-foreground shadow-2xl transition-all duration-500"
    >
    <button hlmBtn
        type="button"
        (click)="onNext()"
        class="ml-auto inline-flex items-center gap-2 px-6 py-3 rounded-xl font-bold text-sm shadow-md hover:shadow-lg transition-all"
      >
        Go Next Test
        <ng-icon name="lucideArrowRight" class="size-4" />
      </button>
      <!-- Step 0: Welcome -->
      @if (currentStep() === 0) {

        <app-welcome-step (onContinue)="onNext()" ></app-welcome-step>

        <!-- <div class="text-center mb-10">

          <div
            class="size-30 rounded-2xl mx-auto mb-6 flex items-center justify-center"
            style="background: var(--theme-primary-light)"
          >
            <img src="/assets/icon/ancLogo.jpeg" alt="logo" class="w-40 h-auto" />
          </div>


          <h2 class="text-2xl font-bold mb-2" style="color: var(--theme-text)">
            Welcome — Create Your Account
          </h2>
          <p class="text-slate-500 max-w-md mx-auto text-sm">
            Begin your membership journey with All Nigeria Community Ghana. Follow three simple
            stages below to complete your registration.
          </p>
        </div>


        <div class="space-y-4 max-w-lg mx-auto mb-10">
          <hlm-item
            variant="outline"
            class="transition-all duration-200 hover:shadow-sm"
            style="border-color: var(--border-color); background: var(--theme-bg)"
          >
            <hlm-item-media variant="icon">
              <ng-icon name="lucideFilePenLine" />
            </hlm-item-media>
            <hlm-item-content>
              <hlm-item-title>Complete the Application Form</hlm-item-title>
              <p hlmItemDescription>
                Fill in your personal details, contact information, state of origin, referee
                particulars, and upload your passport photograph and signature.
              </p>
            </hlm-item-content>
          </hlm-item>

          <hlm-item
            variant="outline"
            class="transition-all duration-200 hover:shadow-sm"
            style="border-color: var(--border-color); background: var(--theme-bg)"
          >
            <hlm-item-media variant="icon">
              <ng-icon name="lucideCreditCard" />
            </hlm-item-media>
            <hlm-item-content>
              <hlm-item-title>Make the Payment</hlm-item-title>
              <p hlmItemDescription>
                Pay the application fee securely. A confirmation receipt is generated instantly.
              </p>
            </hlm-item-content>
          </hlm-item>

          <hlm-item
            variant="outline"
            class="transition-all duration-200 hover:shadow-sm"
            style="border-color: var(--border-color); background: var(--theme-bg)"
          >
            <hlm-item-media variant="icon">
              <ng-icon name="lucideVerified" />
            </hlm-item-media>
            <hlm-item-content>
              <hlm-item-title>Verification &amp; Status Check</hlm-item-title>
              <p hlmItemDescription>
                After payment is confirmed, your application enters review. You can track its status
                at any time from the confirmation screen.
              </p>
            </hlm-item-content>
          </hlm-item>
        </div>


        <div class="flex justify-center">
          <button hlmBtn
            type="button"
            (click)="onNext()"
            class="inline-flex items-center gap-2 px-8 py-3.5 rounded-xl text-white font-semibold text-sm transition-all duration-300 shadow-md hover:shadow-lg transform hover:-translate-y-0.5"
            style="background: var(--theme-primary)"
          >
            Continue to Form
            <ng-icon name="matArrowForwardOutline"></ng-icon>
          </button>
        </div> -->
      }

      <!-- Step 1: Fill Form -->
      @if (currentStep() === 1) {

        <!-- <app-application-form-step></app-application-form-step> -->

        <!-- Official letterhead -->
        <header
          class="relative flex flex-col items-center gap-6 mb-8 overflow-hidden rounded-2xl border border-border/70 bg-slate-50/70 p-6 sm:flex-row sm:items-center sm:p-8"
        >
          <div class="brand-gradient-bar absolute top-0 left-0 right-0 h-1"></div>

          <div class="shrink-0">
            <div
              class="w-24 h-24 rounded-full border-[3px] border-[#0A3D2F]/15 overflow-hidden bg-white flex items-center justify-center shadow-md"
            >
              <img
                src="/assets/icon/ancLogo.jpeg"
                alt="ANC Logo"
                class="w-full h-full object-cover"
                onerror="this.style.opacity = '0.2'"
              />
            </div>
          </div>

          <div class="flex flex-col items-center flex-1 gap-1.5 text-center">
            <h2 class="text-lg sm:text-2xl font-extrabold tracking-tight text-deep-green">
              ALL NIGERIA COMMUNITY GHANA
            </h2>
            <p class="text-sm text-muted-foreground">
              22 Achimota-Legon Road, behind Pure Fire, Kisseman
            </p>
            <p class="text-sm text-muted-foreground">TEL: 024 484 4081</p>
            <span
              hlmBadge
              variant="outline"
              class="mt-1 text-[10px] font-bold tracking-[2px] uppercase text-gold border-gold/30 bg-gold-light px-3 py-1 rounded-full"
            >
              One Nation, One People
            </span>
            <div
              class="mt-3 px-4 py-1.5 text-xs sm:text-sm font-bold tracking-wide uppercase text-white bg-deep-green rounded-lg shadow-sm"
            >
              Membership Registration Form
            </div>
          </div>

          <div class="hidden sm:block w-24 shrink-0"></div>
        </header>

        <form [formGroup]="ancForm" (ngSubmit)="onSubmit()">
          <div hlmFieldGroup>
            <fieldset hlmFieldSet>
              <hlm-field-separator class="col-span-full" />
              <legend hlmFieldLegend>Personal Information</legend>

              <div hlmFieldGroup class="grid grid-cols-1 gap-6 md:grid-cols-2">
                <div hlmField class="col-span-full">
                  <label hlmFieldLabel for="fullName">Full Name</label>
                  <input
                    hlmInput
                    id="fullName"
                    type="text"
                    placeholder="John Doe"
                    formControlName="fullName"
                    class="w-full px-4 py-3 rounded-lg border focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/60 transition duration-150 ease-in-out"
                    required
                  />
                  <hlm-field-error>{{ getErrorMessage('fullName') }}</hlm-field-error>
                </div>

                <div hlmField class="col-span-full">
                  <label hlmFieldLabel for="name_of_kvtl">NAME OF KIN, VILLAGE, TOWN, & LGA</label>
                  <input
                    hlmInput
                    id="name_of_kvtl"
                    type="text"
                    formControlName="name_of_kvtl"
                    class="w-full px-4 py-3 rounded-lg border focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/60 transition duration-150 ease-in-out"
                    required
                  />
                  <hlm-field-error>{{ getErrorMessage('name_of_kvtl') }}</hlm-field-error>
                </div>

                <div hlmField>
                  <label hlmFieldLabel for="phoneNumber">PHONE NUMBER</label>
                  <input
                    hlmInput
                    id="phoneNumber"
                    type="tel"
                    maxlength="10"
                    pattern="^0\d{9}$"
                    formControlName="phoneNumber"
                    placeholder="Phone Number (e.g., 0123456789)"
                    class="w-full px-4 py-3 rounded-lg border focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/60 transition duration-150 ease-in-out"
                    required
                  />
                  <p hlmFieldDescription class="text-xs">
                    This will be your registration phone number
                  </p>
                  <hlm-field-error>{{ getErrorMessage('phoneNumber') }}</hlm-field-error>
                </div>

                <div hlmField>
                  <label hlmFieldLabel for="dateOfBirth">DATE OF BIRTH</label>
                  <input
                    hlmInput
                    id="dateOfBirth"
                    type="date"
                    formControlName="dateOfBirth"
                    class="w-full px-4 py-3 rounded-lg border focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/60 transition duration-150 ease-in-out"
                    required
                  />
                  <!-- <hlm-date-picker captionLayout="dropdown" [maxDate]="maxDate()" [defaultFocusedDate]="defaultFocusedDate">
                <hlm-date-picker-input inputId="date-birthday-input" placeholder="dd.MM.yyyy" showClear="true"
                  openOnClick="true" />

              </hlm-date-picker> -->
                  <hlm-field-error>{{ getErrorMessage('dateOfBirth') }}</hlm-field-error>
                </div>

                <div hlmField>
                  <label hlmFieldLabel for="occupation">OCCUPATION</label>
                  <input
                    hlmInput
                    id="occupation"
                    type="text"
                    placeholder="Occupation"
                    formControlName="occupation"
                    class="w-full px-4 py-3 rounded-lg border focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/60 transition duration-150 ease-in-out"
                    required
                  />
                  <hlm-field-error>{{ getErrorMessage('occupation') }}</hlm-field-error>
                </div>

                <div hlmField>
                  <label hlmFieldLabel for="email">EMAIL</label>
                  <input
                    hlmInput
                    id="email"
                    type="email"
                    placeholder="Email Address"
                    formControlName="email"
                    class="w-full px-4 py-3 rounded-lg border focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/60 transition duration-150 ease-in-out"
                    required
                  />
                  <hlm-field-error>{{ getErrorMessage('email') }}</hlm-field-error>
                </div>

                <div hlmField>
                  <label hlmFieldLabel for="maritalStatus">Marital Status</label>
                  <hlm-select id="maritalStatus" formControlName="maritalStatus" [itemToString]="itemToStringMaritalStatus" >
                    <hlm-select-trigger
                      class="w-full rounded-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/60 transition duration-150 ease-in-out"
                    >
                      <hlm-select-value placeholder="Select an option" />
                    </hlm-select-trigger>
                    <hlm-select-content *hlmSelectPortal class="">
                      <hlm-select-group>
                        <hlm-select-label>Status</hlm-select-label>
                        @for (status of maritalStatus; track status.value) {
                          <hlm-select-item
                            [value]="status.value"
                            class="data-highlighted:bg-primary/10 data-highlighted:text-primary"
                            >{{ status.label }}</hlm-select-item
                          >
                        }
                      </hlm-select-group>
                    </hlm-select-content>
                  </hlm-select>
                  <hlm-field-error>{{ getErrorMessage('maritalStatus') }}</hlm-field-error>
                </div>

                <div hlmField>
                  <label hlmFieldLabel for="region">Region</label>
                  <hlm-select id="region" formControlName="region" [itemToString]="itemToStringRegionList">
                    <hlm-select-trigger
                      class="w-full rounded-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/60 transition duration-150 ease-in-out"
                    >
                      <hlm-select-value placeholder="Select an option" />
                    </hlm-select-trigger>
                    <hlm-select-content *hlmSelectPortal class="">
                      <hlm-select-group>
                        <hlm-select-label>Regions</hlm-select-label>
                        @for (list of regionList; track list.value) {
                          <hlm-select-item
                            [value]="list.value"
                            class="data-highlighted:bg-primary/10 data-highlighted:text-primary"
                            >{{ list.label }}</hlm-select-item
                          >
                        }
                      </hlm-select-group>
                    </hlm-select-content>
                  </hlm-select>
                  <hlm-field-error>{{ getErrorMessage('region') }}</hlm-field-error>
                </div>

                <div hlmField class="col-span-full">
                  <label hlmFieldLabel for="ghanaAddress">RESIDENTIAL ADDRESS IN GHANA</label>
                  <input
                    hlmInput
                    id="ghanaAddress"
                    type="text"
                    placeholder="Address in Ghana"
                    formControlName="ghanaAddress"
                    class="w-full px-4 py-3 rounded-lg border focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/60 transition duration-150 ease-in-out"
                    required
                  />
                  <hlm-field-error>{{ getErrorMessage('ghanaAddress') }}</hlm-field-error>
                </div>

                <div hlmField class="col-span-full">
                  <label hlmFieldLabel for="nigeriaAddress">RESIDENTIAL ADDRESS IN NIGERIA</label>
                  <input
                    hlmInput
                    id="nigeriaAddress"
                    type="text"
                    placeholder="Address in Nigeria"
                    formControlName="nigeriaAddress"
                    class="w-full px-4 py-3 rounded-lg border focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/60 transition duration-150 ease-in-out"
                    required
                  />
                  <hlm-field-error> {{ getErrorMessage('nigeriaAddress') }}</hlm-field-error>
                </div>

                <div hlmField>
                  <label hlmFieldLabel for="localGovernment">Local Gov't Area</label>
                  <input
                    hlmInput
                    id="localGovernment"
                    type="text"
                    placeholder="Local Government Area"
                    formControlName="localGovernment"
                    class="w-full px-4 py-3 rounded-lg border focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/60 transition duration-150 ease-in-out"
                    required
                  />
                  <hlm-field-error>{{ getErrorMessage('localGovernment') }}</hlm-field-error>
                </div>

                <div hlmField>
                  <label hlmFieldLabel for="stateOrigin">State of Origin</label>
                  <input
                    hlmInput
                    id="stateOrigin"
                    type="text"
                    placeholder="State of Origin"
                    formControlName="stateOrigin"
                    class="w-full px-4 py-3 rounded-lg border focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/60 transition duration-150 ease-in-out"
                    required
                  />
                  <hlm-field-error>{{ getErrorMessage('stateOrigin') }}</hlm-field-error>
                </div>

                <div hlmField class="col-span-full">
                  <label hlmFieldLabel for="refereesNames">Name of Referees in Ghana</label>
                  <input
                    hlmInput
                    id="refereesNames"
                    type="text"
                    placeholder="Names of Referees in Ghana"
                    formControlName="refereesNames"
                    class="w-full px-4 py-3 rounded-lg border focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/60 transition duration-150 ease-in-out"
                    required
                  />
                  <hlm-field-error>{{ getErrorMessage('refereesNames') }}</hlm-field-error>
                </div>

                <div hlmField>
                  <label hlmFieldLabel for="refereesPhoneNumber">Phone Number of Referees</label>
                  <input
                    hlmInput
                    id="refereesPhoneNumber"
                    type="text"
                    placeholder="Phone Number of Referees"
                    formControlName="refereesPhoneNumber"
                    class="w-full px-4 py-3 rounded-lg border focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/60 transition duration-150 ease-in-out"
                    required
                  />
                  <hlm-field-error>{{ getErrorMessage('refereesPhoneNumber') }}</hlm-field-error>
                </div>

                <div hlmField>
                  <label hlmFieldLabel for="refereesAddress">Address of Referees</label>
                  <input
                    hlmInput
                    id="refereesAddress"
                    type="text"
                    placeholder="Address of Referees"
                    formControlName="refereesAddress"
                    class="w-full px-4 py-3 rounded-lg border focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/60 transition duration-150 ease-in-out"
                    required
                  />
                  <hlm-field-error>{{ getErrorMessage('refereesAddress') }}</hlm-field-error>
                </div>
              </div>
            </fieldset>

            <fieldset hlmFieldSet>
              <hlm-field-separator />
              <legend hlmFieldLegend>Details of Beneficiary</legend>

              <div hlmFieldGroup class="grid grid-cols-1 gap-6 md:grid-cols-2">
                <div hlmField>
                  <label hlmFieldLabel for="benNextOfKin">Next of Kin</label>
                  <input
                    hlmInput
                    id="benNextOfKin"
                    type="text"
                    placeholder="Next of Kin"
                    formControlName="benNextOfKin"
                    class="w-full px-4 py-3 rounded-lg border focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/60 transition duration-150 ease-in-out"
                    required
                  />
                  <hlm-field-error>{{ getErrorMessage('benNextOfKin') }}</hlm-field-error>
                </div>

                <div hlmField>
                  <label hlmFieldLabel for="benRelationship">Relationship to Beneficiary</label>
                  <input
                    hlmInput
                    id="benRelationship"
                    type="text"
                    placeholder="Relationship to Beneficiary"
                    formControlName="benRelationship"
                    class="w-full px-4 py-3 rounded-lg border focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/60 transition duration-150 ease-in-out"
                    required
                  />
                  <hlm-field-error>{{ getErrorMessage('benRelationship') }}</hlm-field-error>
                </div>

                <div hlmField>
                  <label hlmFieldLabel for="benPhoneNumber">Contact</label>
                  <input
                    hlmInput
                    id="benPhoneNumber"
                    type="tel"
                    placeholder="Beneficiary Phone Number (e.g., 0123456789)"
                    formControlName="benPhoneNumber"
                    maxlength="10"
                    pattern="^0\d{9}$"
                    class="w-full px-4 py-3 rounded-lg border focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/60 transition duration-150 ease-in-out"
                    required
                  />
                  <hlm-field-error>{{ getErrorMessage('benPhoneNumber') }}</hlm-field-error>
                </div>
              </div>
            </fieldset>

            <fieldset hlmFieldSet>
              <hlm-field-separator />
              <legend hlmFieldLegend>Declaration</legend>

              <hlm-field-group>
                <div
                  hlmField
                  orientation="horizontal"
                  class="flex items-start gap-3 rounded-xl border border-border/70 bg-slate-50/70 p-4"
                >
                  <hlm-checkbox
                    inputId="declaration"
                    formControlName="declaration"
                    class="size-6 shrink-0 data-checked:bg-primary data-checked:border-primary"
                  />
                  <label hlmFieldLabel for="declaration" class="text-sm leading-relaxed">
                    I <span class="font-bold text-deep-green">{{ ancForm.value.fullName || '—' }}</span>
                    solemnly declare the above particulars given by me to be true in substance and
                    material facts:
                  </label>
                </div>
                @if (isFieldInvalid('declaration')) {
                  <p class="mt-1 text-xs font-medium text-destructive">
                    {{ getErrorMessage('declaration') }}
                  </p>
                }
              </hlm-field-group>
            </fieldset>

            <fieldset hlmFieldSet>
              <!-- <div hlmAttachment class="w-400" orientation="vertical">
            <div hlmAttachmentMedia variant="image" class="w-400">
              <img src="/assets/icon/ancLogo.jpeg" alt="logo" class="w-400 h-auto " onerror="this.style.display='none'">
            </div>
            <div hlmAttachmentContent>
              <span hlmAttachmentTitle>sales-dashboard.pdf</span>
              <span hlmAttachmentDescription>Uploading · 64%</span>
            </div>
            <div hlmAttachmentActions>
              <button hlmAttachmentAction aria-label="Cancel upload">
              </button>
            </div>
          </div> -->

              <hlm-field-separator />
              <legend hlmFieldLegend>Photograph &amp; Signature</legend>

              <div hlmFieldGroup class="grid grid-cols-1 gap-6 md:grid-cols-2">
                <!-- Passport photograph -->
                <div hlmField class="flex flex-col h-full">
                  <label hlmFieldLabel class="mb-2">Passport Photograph</label>

                  <label
                    for="passport"
                    (click)="openModal()"
                    [hidden]="passportPreview()"
                    class="upload-dropzone flex flex-col items-center justify-center gap-2 w-full text-base font-semibold border-2 border-dashed rounded-xl cursor-pointer text-muted-foreground h-55"
                    [class.is-invalid]="isFieldInvalid('passport') && !passportPreview()"
                  >
                    <ng-icon size="44" name="lucideCamera" />
                    Take Photo
                    <span class="text-xs font-medium text-slate-400">Max file size 2MB.</span>
                  </label>

                  @if (passportError()) {
                    <p class="mt-1.5 text-xs font-medium text-destructive">{{ passportError() }}</p>
                  }
                  @if (isFieldInvalid('passport') && !passportError() && !passportPreview()) {
                    <p class="mt-1.5 text-xs font-medium text-destructive">
                      {{ getErrorMessage('passport') }}
                    </p>
                  }

                  @if (passportPreview()) {
                    <div
                      class="flex flex-col items-center gap-2 p-3 mt-1 rounded-xl border border-border/70 bg-slate-50/70"
                    >
                      <img
                        [src]="passportPreview()"
                        alt="Passport Preview"
                        class="rounded-lg shadow-md h-45 object-cover"
                      />
                      <div class="text-xs text-muted-foreground">
                        Size: {{ passportSize() / (1024 * 1024) | number: '1.2-2' }} MB
                      </div>
                      <button
                        type="button"
                        hlmBtn
                        variant="outline"
                        size="sm"
                        class="text-destructive border-destructive/30 hover:bg-destructive/5 rounded-lg"
                        (click)="clearPassport()"
                      >
                        Clear
                      </button>
                    </div>
                  }
                </div>

                <!-- Signature: draw or upload -->
                <div hlmField class="flex flex-col h-full">
                  <label hlmFieldLabel class="mb-2">Signature</label>

                  <hlm-tabs
                    [tab]="segmentValue()"
                    (tabActivated)="segmentValue.set($event)"
                    class="w-full h-full"
                  >
                    <hlm-tabs-list class="gap-1">
                      <button
                        hlmTabsTrigger="first"
                        [disabled]="signatureFilePreview()"
                        class="rounded-lg font-semibold data-active:bg-primary data-active:text-primary-foreground data-active:shadow-sm"
                      >
                        Signature pad
                      </button>
                      <button
                        hlmTabsTrigger="second"
                        [disabled]="signaturePadPreview()"
                        class="rounded-lg font-semibold data-active:bg-primary data-active:text-primary-foreground data-active:shadow-sm"
                      >
                        Upload
                      </button>
                    </hlm-tabs-list>

                    <div hlmTabsContent="first" class="h-55">
                      <ng-template hlmTabsContentLazy>
                        <section
                          hlmCard
                          class="flex flex-col justify-between gap-3 p-3 rounded-xl border bg-card"
                          [hidden]="signaturePadPreview()"
                          [class.border-destructive]="isFieldInvalid('signature')"
                        >
                          <canvas #sigPadCanvas class="signature-canvas w-full h-40"></canvas>
                          <div class="flex flex-row gap-3">
                            <button
                              type="button"
                              hlmBtn
                              size="sm"
                              class="grow rounded-lg font-semibold"
                              (click)="saveSignature()"
                            >
                              Save
                            </button>
                            <button
                              type="button"
                              hlmBtn
                              variant="outline"
                              size="sm"
                              class="grow rounded-lg font-semibold text-destructive border-destructive/30 hover:bg-destructive/5"
                              (click)="clearSignaturePad()"
                            >
                              Clear
                            </button>
                          </div>
                        </section>

                        <!-- Signature Preview -->
                        @if (signaturePadPreview()) {
                          <div
                            class="flex flex-col items-center gap-2 p-3 rounded-xl border border-border/70 bg-slate-50/70"
                          >
                            <img
                              [src]="signaturePadPreview()"
                              alt="Signature Preview"
                              class="rounded-lg shadow-sm bg-white"
                            />
                            <button
                              type="button"
                              hlmBtn
                              variant="outline"
                              size="sm"
                              class="rounded-lg text-destructive border-destructive/30 hover:bg-destructive/5"
                              (click)="clearSignaturePadPreview()"
                            >
                              Clear Preview
                            </button>
                          </div>
                        }
                      </ng-template>
                    </div>

                    <div hlmTabsContent="second">
                      <ng-template hlmTabsContentLazy>
                        <label
                          for="signature"
                          [hidden]="signatureFilePreview()"
                          class="upload-dropzone flex flex-col w-full items-center justify-center gap-2 text-base font-semibold border-2 border-dashed rounded-xl cursor-pointer text-muted-foreground h-55"
                          [class.is-invalid]="isFieldInvalid('signature') && !signatureFilePreview()"
                        >
                          <ng-icon size="44" name="lucideCloudUpload" />
                          Upload Signature
                          <input
                            type="file"
                            id="signature"
                            accept=".jpg,.jpeg,.png"
                            #signatureInput
                            class="hidden"
                            (change)="onSignatureFileChange($event)"
                          />
                          <span class="text-xs font-medium text-slate-400">
                            PNG and JPG are allowed. Max 2MB.
                          </span>
                        </label>

                        @if (signatureFileError()) {
                          <p class="mt-1.5 text-xs font-medium text-destructive">
                            {{ signatureFileError() }}
                          </p>
                        }

                        @if (signatureFilePreview()) {
                          <div
                            class="flex flex-col items-center gap-2 p-3 rounded-xl border border-border/70 bg-slate-50/70"
                          >
                            <img
                              [src]="signatureFilePreview()"
                              alt="Signature File Preview"
                              class="rounded-lg shadow-sm bg-white h-45 object-contain"
                            />
                            <div class="text-xs text-muted-foreground">
                              Size: {{ signatureFileSize() / (1024 * 1024) | number: '1.2-2' }} MB
                            </div>
                            <button
                              type="button"
                              hlmBtn
                              variant="outline"
                              size="sm"
                              class="rounded-lg text-destructive border-destructive/30 hover:bg-destructive/5"
                              (click)="clearSignatureFile()"
                            >
                              Clear
                            </button>
                          </div>
                        }
                      </ng-template>
                    </div>
                  </hlm-tabs>

                  @if (
                    isFieldInvalid('signature') &&
                    !signatureFileError() &&
                    !signatureFilePreview() &&
                    !signaturePadPreview()
                  ) {
                    <p class="mt-1.5 text-xs font-medium text-destructive">
                      {{ getErrorMessage('signature') }}
                    </p>
                  }
                </div>
              </div>
            </fieldset>

            <div class="space-y-3">
              <button
                hlmBtn
                type="submit"
                [disabled]="isLoading()"
                class="w-full py-3.5 rounded-xl font-bold text-sm tracking-wide transition-all duration-300 shadow-md hover:shadow-lg hover:-translate-y-0.5 active:translate-y-0 disabled:hover:translate-y-0"
              >
                @if (isLoading()) {
                  <hlm-spinner class="text-base md:text-lg" />
                  <span class="ml-2">Submitting application...</span>
                } @else {
                  <span>Create Account</span>
                  <ng-icon name="matArrowForwardOutline" class="ml-1.5" />
                }
              </button>
              <p class="text-center text-xs text-muted-foreground">
                <ng-icon size="14" name="lucideLockKeyhole" class="inline-block align-text-bottom text-gold" />
                Your information is transmitted securely and used only for membership processing.
              </p>
            </div>
          </div>
        </form>
      }

      <!-- Step 2: Payment -->
      @if (currentStep() === 2) {
        <app-payment-form-step (onContinue)="onPaymentContinue($event)"></app-payment-form-step>

        <!-- <div class="text-center mb-8">
          <div
            class="w-16 h-16 rounded-2xl mx-auto mb-5 flex items-center justify-center"
            style="background: var(--theme-primary-dark)"
          >
            <svg class="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
              />
            </svg>
          </div>
          <h2 class="text-2xl font-bold mb-2" style="color: var(--theme-text)">Payment</h2>
          <p class="text-slate-500 max-w-md mx-auto">
            Enter your payment details to complete the application fee.
          </p>
        </div>
        <form
          [formGroup]="paymentForm"
          (ngSubmit)="onPaymentSubmit()"
          class="space-y-5 max-w-md mx-auto"
        >
          <div hlmCard
            class="rounded-xl p-4"
            style="background: var(--theme-bg); border: 1px solid var(--border-color)"
          >
            <div class="flex justify-between items-center mb-2">
              <span class="text-sm" style="color: var(--text-muted)">Application Fee</span>
              <span class="font-bold" style="color: var(--theme-text)">
                {{ formSubData()?.user?.amount | currency: 'GHS ' : 'symbol' : '1.2-2' }}
              </span>
            </div>
            <div class="flex justify-between items-center">
              <span class="text-sm" style="color: var(--text-muted)">Processing</span>
              <span class="font-bold" style="color: var(--theme-primary)">Due Now</span>
            </div>
          </div>

          <div hlmFieldGroup>
            <fieldset hlmFieldSet>
              <div hlmFieldGroup class="grid grid-cols-1 gap-6 md:grid-cols-2">
                <div hlmField class="col-span-full">
                  <label hlmFieldLabel for="payment_number">Mobile Money Number</label>
                  <input
                    hlmInput
                    id="payment_number"
                    type="tel"
                    maxlength="10"
                    pattern="^0\d{9}$"
                    formControlName="payment_number"
                    placeholder="Enter your Momo number"
                    class="w-full px-4 py-3 rounded-lg border focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/60 transition duration-150 ease-in-out"
                    required
                  />

                  <hlm-field-error>{{ getErrorMessagePayment('payment_number') }}</hlm-field-error>
                </div>

                <div hlmField>
                  <label hlmFieldLabel for="network">Network</label>
                  <hlm-select id="network" formControlName="network" [itemToString]="itemToStringNetworkList">
                    <hlm-select-trigger
                      class="w-full rounded-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/60 transition duration-150 ease-in-out"
                    >
                      <hlm-select-value placeholder="Select an option" />
                    </hlm-select-trigger>
                    <hlm-select-content *hlmSelectPortal class="">
                      <hlm-select-group>
                        <hlm-select-label>Payment Network</hlm-select-label>
                        @for (list of networkList; track list.value) {
                          <hlm-select-item
                            [value]="list.value"
                            class="data-highlighted:bg-primary/10 data-highlighted:text-primary"
                            >{{ list.label }}</hlm-select-item
                          >
                        }
                      </hlm-select-group>
                    </hlm-select-content>
                  </hlm-select>
                  <hlm-field-error>{{ getErrorMessagePayment('network') }}</hlm-field-error>
                </div>

                <div hlmField>
                  <label hlmFieldLabel for="serial_number">Serial Number </label>
                  <input
                    hlmInput
                    id="serial_number"
                    [value]="formSubData()?.user?.serial_number"
                    type="text"
                    placeholder=""
                    class="w-full px-4 py-3 font-bold rounded-lg border focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/60 transition duration-150 ease-in-out"
                    required
                    [disabled]="true"
                  />

                  <hlm-field-error>{{ getErrorMessagePayment('serial_number') }}</hlm-field-error>
                </div>
              </div>
            </fieldset>
          </div>

          <button
            hlmBtn
            type="submit"
            class="w-full py-3.5 rounded-xl text-white font-bold text-sm transition-all duration-300 shadow-md hover:shadow-lg"
            style="background: var(--theme-primary)"
          >
            @if (isPaymentLoading()) {
              <hlm-spinner class="text-base md:text-lg" />
              Sending payment request...
            } @else {
              <span>Complete Payment</span>
            }
          </button>
          <p class="text-center text-xs text-slate-400">
            <ng-icon
              size="15"
              class="inline-block impo align-top!"
              name="lucideLockKeyhole"
            ></ng-icon>
            Your payment information is encrypted and secure
          </p>
        </form> -->

      }

      <!-- Step 3: Confirmation -->
      @if (currentStep() === 3) {
        <app-payment-status-step (onContinue)="onPaymentStatusContinue($event)"></app-payment-status-step>

        <!-- @if (paymentState() === 'pending') {
          <div class="text-center mb-8">
            <div
              class="w-20 h-20 rounded-full mx-auto mb-5 flex items-center justify-center payment-pending-icon"
              style="background: #fef3c7; border-color: #f59e0b"
            >
              <ng-icon name="lucideTimer" class="w-10 h-10 text-amber-600" />
            </div>
            <h2 class="text-2xl font-bold mb-2" style="color: var(--theme-text)">
              Payment Submitted
            </h2>
            <p class="text-slate-500 max-w-md mx-auto">
              Your payment request is being processed. This usually takes a few minutes.
            </p>
          </div>

          <div hlmCard

            class="rounded-xl p-6 text-center"
            style="background: var(--theme-bg); border: 1px solid var(--border-color)"
          >
          @if (isCheckingPayment()) {
            <hlm-spinner class="text-2xl mx-auto" />
            <p class="text-sm font-medium" style="color: var(--theme-text)">
              Waiting for payment confirmation...
            </p>
            <p class="text-xs text-slate-400">
              We'll automatically check the status for you
            </p>
          }@else {
            <p class="text-sm font-medium" style="color: var(--theme-text)">
                Unable to confirm payment
              </p>
              <p class="text-xs text-slate-400">
              Please authorize payment or try checking again
            </p>
            <div>

              <button hlmBtn type="button" variant="outline"  (click)="retryPaymentStatusCheck()" >
                        Check again
                      </button>
            </div>


          }


          </div>

        }

        @if (paymentState() === 'failed') {
          <div class="text-center mb-8">
            <div
              class="w-20 h-20 rounded-full mx-auto mb-5 flex items-center justify-center payment-failed-icon"
              style="background: #fee2e2; border-color: #ef4444"
            >
              <ng-icon name="lucideTriangleAlert" class="w-10 h-10 text-red-600" />
            </div>
            <h2 class="text-2xl font-bold mb-2" style="color: var(--theme-text)">
              Payment Failed
            </h2>
            <p class="text-slate-500 max-w-md mx-auto">
              Unfortunately, your payment could not be processed. Please try again.
            </p>
          </div>

          <div hlmCard
            class="rounded-xl p-6 mb-6"
            style="background: var(--theme-bg); border: 1px solid var(--border-color)"
          >
          <div
                class="w-12 h-12 rounded-full mx-auto mb-3 flex items-center justify-center"
                style="background: #fee2e2"
              >
                <ng-icon size="16" name="lucideX" class="text-red-600"></ng-icon>
              </div>
            <div class="text-center">

              <h3 class="font-semibold text-red-600">Transaction Failed</h3>
              <p class="text-xs text-slate-500 mt-1">
                Your payment was not verified by the payment provider
              </p>
            </div>

            <div class="text-center">
              <button hlmBtn type="button" variant="outline"  (click)="onBack()" >
                        Try again
                      </button>
            </div>


              <hlm-separator class="bg-(--border-color)" />

            <div
              class="flex justify-between items-center pt-3"
            >
              <span class="text-sm" style="color: var(--text-muted)">Serial Number</span>
              <span class="font-bold font-mono" style="color: var(--theme-primary)">
                {{ formSubData()?.user?.serial_number || 'N/A' }}
              </span>
            </div>
          </div>
        }

        @if (paymentState() === 'success') {
          <div class="text-center mb-8">
            <div
              class="w-20 h-20 rounded-full mx-auto mb-5 flex items-center justify-center step-complete"
              style="
                background: var(--theme-success) !important;
                border-color: var(--theme-success) !important;
              "
            >
              <ng-icon size="30" name="lucideCheck" class="text-white" />
            </div>
            <h2 class="text-2xl font-bold mb-2" style="color: var(--theme-text)">
              Payment Confirmed
            </h2>
            <p class="text-slate-500 max-w-md mx-auto">
              Your payment has been processed successfully!
            </p>
          </div>

          <div
            class="rounded-xl p-6 mb-6"
            style="background: var(--theme-bg); border: 1px solid var(--border-color)"
          >
            <div
              class="flex justify-between items-center mb-3 pb-3"
              style="border-bottom: 1px solid var(--border-color)"
            >
              <span class="text-sm" style="color: var(--text-muted)">Serial Number</span>
              <span class="font-bold font-mono" style="color: var(--theme-primary)">
                {{ formSubData()?.user?.serial_number }}
              </span>
            </div>
            <div class="flex justify-between items-center">
              <span class="text-sm" style="color: var(--text-muted)">Status</span>
              <span
                class="text-sm font-semibold px-3 py-1 rounded-full"
                style="background: #dcfce7; color: #166534"
                >Paid & Verified</span
              >
            </div>
          </div>

          <div class="text-center space-y-3">
            <p class="text-sm text-slate-500 mb-2">You can now check your application status.</p>
            <button
              type="button"

              class="inline-flex items-center gap-2 px-8 py-3.5 rounded-xl text-white font-bold text-sm transition-all duration-300 shadow-md hover:shadow-lg"
              style="background: var(--theme-primary)"
            >
              Check Status
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M17 8l4 4m0 0l-4 4m4-4H3"
                />
              </svg>
            </button>
          </div>
        } -->

      }

      <!-- Step 4: Final Status -->
      @if (currentStep() === 4) {
        <app-status-check-step></app-status-check-step>

        <!-- <div class="text-center mb-6">
          <div class="w-20 h-20 rounded-full mx-auto mb-4 flex items-center justify-center" style="background:var(--theme-secondary)">
            <ng-icon name="lucideVerified" class="w-10 h-10 text-white"></ng-icon>
          </div>
          <h2 class="text-2xl font-bold mb-2" style="color: var(--theme-text)">Application Status</h2>
          <p class="text-slate-500 max-w-md mx-auto">Below is the current status of your application. Use "View Submitted Application" to see the data you provided.</p>
        </div>

        <div class="rounded-xl p-6" style="background: var(--theme-bg); border: 1px solid var(--border-color)">


          @if (applicationLoading()) {
            <div class="flex flex-col items-center gap-3 py-6">
              <hlm-skeleton class="w-48 h-6" />
              <hlm-skeleton class="w-32 h-4" />
              <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 w-full mt-4">
                <hlm-skeleton class="h-10" />
                <hlm-skeleton class="h-10" />
                <hlm-skeleton class="h-10" />
                <hlm-skeleton class="h-10" />
              </div>
              <hlm-spinner class="text-2xl mt-4" />
            </div>
          }@else {


            @if (applicationError()) {
              <div class="text-center py-6">
                <div class="w-12 h-12 rounded-full mx-auto mb-3 flex items-center justify-center" style="background:#fee2e2">
                  <ng-icon name="lucideX" class="w-6 h-6 text-red-600"></ng-icon>
                </div>
                <h3 class="font-semibold text-red-600">{{ applicationError() }}</h3>
                <p class="text-xs text-slate-500 mt-2">If you believe this is an error, please contact support or try checking again.</p>

                <div class="mt-4 flex items-center justify-center gap-3">
                  <button hlmBtn type="button" variant="outline" (click)="checkApplicationStatus()">Check Again</button>
                  <button hlmBtn type="button" (click)="toggleSubmittedApplication()">View Submitted Application</button>
                </div>
              </div>
            }@else {


              @if (applicationStatus() === 'approved') {
                <div class="text-center mb-4">
                  <div class="w-14 h-14 rounded-full mx-auto mb-3 flex items-center justify-center step-complete" style="background:var(--theme-success)">
                    <ng-icon name="lucideCheck" class="w-7 h-7 text-white"></ng-icon>
                  </div>
                  <h3 class="text-lg font-bold">Application Approved</h3>
                  <p class="text-sm text-slate-500">Your application has been approved and a policy has been issued.</p>
                </div>

                <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                  <div>
                    <div class="text-sm text-slate-500">Full Name</div>
                    <div class="font-semibold" style="color:var(--theme-text)">{{ applicationData()?.full_name || formSubData()?.fullName || 'N/A' }}</div>
                  </div>
                  <div>
                    <div class="text-sm text-slate-500">Mobile</div>
                    <div class="font-semibold">{{ applicationData()?.mobile_number || formSubData()?.phoneNumber || 'N/A' }}</div>
                  </div>

                  <div>
                    <div class="text-sm text-slate-500">Registration No.</div>
                    <div class="font-mono font-semibold" style="color:var(--theme-primary)">{{ applicationData()?.registration_number || 'N/A' }}</div>
                  </div>
                  <div>
                    <div class="text-sm text-slate-500">Serial Number</div>
                    <div class="font-mono font-semibold" style="color:var(--theme-primary)">{{ applicationData()?.serial_number || formSubData()?.user?.serial_number || 'N/A' }}</div>
                  </div>

                  <div>
                    <div class="text-sm text-slate-500">Region</div>
                    <div class="font-semibold">{{ applicationData()?.region || 'N/A' }}</div>
                  </div>

                  <div>
                    <div class="text-sm text-slate-500">Approved By</div>
                    <div class="font-semibold">{{ applicationData()?.approved_by ? (applicationData()?.approved_by) : 'N/A' }}</div>
                  </div>
                </div>

                <div class="mb-4">
                  <h4 class="font-semibold mb-2">Policy</h4>
                  @if (applicationData()?.policy){
                    <div class="grid grid-cols-1 sm:grid-cols-3 gap-3">
                      <div class="text-sm text-slate-500">Policy Number</div>
                      <div class="font-semibold col-span-2">{{ applicationData()?.policy?.policy_number }}</div>
                      <div class="text-sm text-slate-500">Start Date</div>
                      <div class="font-semibold">{{ applicationData()?.policy?.start_date }}</div>
                      <div class="text-sm text-slate-500">End Date</div>
                      <div class="font-semibold">{{ applicationData()?.policy?.end_date }}</div>
                    </div>
                  }

                  @else{
                    <p class="text-xs text-slate-500">Policy information not available.</p>
                  }


                </div>

                <div class="flex items-center justify-center gap-3">
                  <button hlmBtn type="button" (click)="toggleSubmittedApplication()">View Submitted Application</button>
                  <a routerLink="/" class="inline-flex items-center gap-2 px-4 py-2 rounded-xl text-sm border" style="color:var(--text-muted); border-color:var(--border-color)">Return Home</a>
                </div>

              }@else if (applicationStatus() === 'pending') {

                <div class="text-center py-6">
                  <hlm-spinner class="text-2xl mx-auto mb-3" />
                  <h3 class="text-lg font-bold">Application Pending</h3>
                  <p class="text-sm text-slate-500">Your application is under review. Please check back later.</p>

                  <div class="mt-4 flex items-center justify-center gap-3">
                    <button hlmBtn type="button" (click)="checkApplicationStatus()" variant="outline">Check Again</button>
                    <button hlmBtn type="button" (click)="toggleSubmittedApplication()">View Submitted Application</button>
                  </div>
                </div>

              }@else if (applicationStatus() === 'cancelled') {

                <div class="text-center py-6">
                  <div class="w-12 h-12 rounded-full mx-auto mb-3 flex items-center justify-center" style="background:#fff4e6">
                    <ng-icon name="lucideTriangleAlert" class="w-6 h-6 text-orange-600"></ng-icon>
                  </div>
                  <h3 class="text-lg font-bold">Application Cancelled</h3>
                  <p class="text-sm text-slate-500">This application has been cancelled. Contact support for more information.</p>

                  <div class="mt-4 flex items-center justify-center gap-3">
                    <button hlmBtn type="button" variant="outline" (click)="checkApplicationStatus()">Check Again</button>
                    <button hlmBtn type="button" (click)="toggleSubmittedApplication()">View Submitted Application</button>
                  </div>
                </div>

              }@else {

                <div class="text-center py-6">
                  <h3 class="text-lg font-bold">No status available</h3>
                  <p class="text-sm text-slate-500">Unable to retrieve application status.</p>
                  <div class="mt-4">
                    <button hlmBtn type="button" (click)="checkApplicationStatus()">Check Again</button>
                    <button hlmBtn type="button" (click)="toggleSubmittedApplication()">View Submitted Application</button>
                  </div>
                </div>
              }


              @if (showSubmittedApplication()) {
                <div class="mt-6 border-t pt-4">
                  <h4 class="font-semibold mb-3">Submitted Application Data</h4>
                  <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
                    <div>
                      <div class="text-sm text-slate-500">Full Name</div>
                      <div class="font-semibold">{{ formSubData()?.fullName || applicationData()?.full_name || 'N/A' }}</div>
                    </div>
                    <div>
                      <div class="text-sm text-slate-500">Phone</div>
                      <div class="font-semibold">{{ formSubData()?.phoneNumber || applicationData()?.mobile_number || 'N/A' }}</div>
                    </div>

                    <div>
                      <div class="text-sm text-slate-500">Registration No.</div>
                      <div class="font-semibold">{{ formSubData()?.registrationNumber || applicationData()?.registration_number || 'N/A' }}</div>
                    </div>

                    <div>
                      <div class="text-sm text-slate-500">Serial Number</div>
                      <div class="font-semibold">{{ formSubData()?.user?.serial_number || applicationData()?.serial_number || 'N/A' }}</div>
                    </div>

                    <div>
                      <div class="text-sm text-slate-500">Region</div>
                      <div class="font-semibold">{{ applicationData()?.region || 'N/A' }}</div>
                    </div>

                    <div>
                      <div class="text-sm text-slate-500">Policy</div>
                      <div class="font-semibold">{{ applicationData()?.policy?.policy_number || 'N/A' }}</div>
                    </div>
                  </div>

                  <div class="mt-4 flex justify-end">
                    <button hlmBtn type="button" variant="ghost" (click)="toggleSubmittedApplication()">Close</button>
                  </div>
                </div>
              }

            }
          }

        </div> -->

      }

      <!-- Navigation -->
      @if (currentStep() < 4 && currentStep() > 0) {
        <div class="flex items-center justify-between mt-8 pt-6 border-t border-border/60">
          <button
            hlmBtn
            variant="outline"
            type="button"
            (click)="onBack()"
            class="inline-flex items-center gap-2 rounded-xl font-semibold text-sm border-deep-green/20 text-deep-green hover:bg-deep-green/5 hover:border-deep-green/40 transition-all"
          >
            <ng-icon name="lucideArrowLeft" class="size-4"></ng-icon>
            Back
          </button>
        </div>
      }
    </div>

    <!-- Support strip, mirroring the landing page's contact affordances -->
    <div
      class="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6 text-xs sm:text-sm text-muted-foreground"
    >
      <p class="flex items-center gap-1.5">
        <ng-icon name="lucideShieldCheck" class="size-3.5 text-gold" />
        <span>Your details are transmitted securely</span>
      </p>
      <span class="hidden sm:inline text-slate-300">•</span>
      <p class="flex items-center gap-1.5">
        <span>Need help?</span>
        <a href="tel:0244844081" class="font-bold text-deep-green hover:text-gold underline underline-offset-2 transition-colors">
          024 484 4081
        </a>
      </p>
    </div>
  </div>

  <app-footer />
</div>
